import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function scrollToPricing() {
  document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    scrollToPricing();
  };
  return <a href="#pricing" onClick={handleClick} className={`block w-full rounded-lg bg-brand-green px-3 py-3 text-center font-heading text-sm font-extrabold uppercase leading-tight tracking-wide text-brand-navy shadow-[0_5px_0_0_#7FA300] transition duration-150 hover:-translate-y-0.5 hover:bg-[#A8D400] focus:outline-none focus:ring-4 focus:ring-brand-green/40 active:translate-y-0.5 active:shadow-[0_2px_0_0_#7FA300] sm:text-base ${className}`} data-id="element-33" data-mp="2ty1q5v991ds7">
      {children}
    </a>;
}